import React from "react";

const Pills = ({
  primary = null,
  secondary = "#5e5e5e",
  viewBox = "10 35 983.58 100.72"
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox={viewBox}
    >
      <defs>
        <mask
          id="a"
          x="0"
          y="0"
          width="2083.58"
          height="120.72"
          maskUnits="userSpaceOnUse"
        >
          <g transform="translate(-16.4 20.85)">
            <rect x="20" y="10" width="1055" height="160" fill="#fff" />
          </g>
        </mask>
      </defs>
      <rect x="3.6" y="30.85" width="1055" height="160" fill={primary} />
      <g mask="url(#a)">
        <rect x="3.77" y="32" width="1055" height="160" fill="#fff" />
        <rect x="3.77" y="32" width="1055" height="160" fill="#d8d8d8" />
        <rect x="3.77" y="32" width="1056" height="160" fill={primary} />
        <rect
          x="17.9"
          y="29.78"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-34.32 43.5) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="35.36"
          y="40.11"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-43.49 59.7) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="49.57"
          y="37.17"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-31.57 65.76) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="32.4"
          y="6.36"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-22.34 49.76) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="41.73"
          y="-13.37"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-7.35 51.1) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="59.3"
          y="17.52"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-16.54 67.38) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="76.85"
          y="28.18"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-25.9 83.72) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="129.71"
          y="66.01"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-31.19 124.5) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="67.55"
          y="47.19"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-40.42 82.22) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="94.54"
          y="24.41"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-12.62 91.84) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="77.38"
          y="-6.41"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-3.38 75.83) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="112.01"
          y="34.74"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-21.79 108.03) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="139.11"
          y="41.48"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-13.08 124.74) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="121.7"
          y="11.39"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-4.36 108.76) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="156.35"
          y="51.03"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-21.79 140.62) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="93.92"
          y="59.65"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-35.58 99.81) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="148.69"
          y="18.09"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(4.34 125.38) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="131.28"
          y="-12"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(13.05 109.4) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="183.1"
          y="58.47"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(-13.61 157.26) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="165.94"
          y="27.67"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-4.38 141.26) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="200.57"
          y="68.82"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-22.78 173.47) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="194.98"
          y="37.12"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(3.03 159.88) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="177.82"
          y="6.31"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(12.27 143.87) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="212.45"
          y="47.46"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-6.14 176.08) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="226.67"
          y="44.52"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(5.78 182.15) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="209.49"
          y="13.71"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(15.01 166.14) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="186.51"
          y="-13.39"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(27.09 144.82) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="218.83"
          y="-6.04"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(30.01 167.49) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="236.38"
          y="24.87"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(20.81 183.77) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="253.95"
          y="35.51"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(11.47 200.1) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="244.65"
          y="54.54"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(-3.06 198.6) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="271.63"
          y="31.76"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(24.73 208.22) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="254.46"
          y="0.94"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(33.97 192.21) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="289.1"
          y="42.1"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(15.56 224.42) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="316.19"
          y="48.83"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 24.27, 241.12)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="298.8"
          y="18.74"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(32.99 225.14) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="333.46"
          y="58.4"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(15.56 257.01) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="271.02"
          y="66.98"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(1.78 216.2) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="325.77"
          y="25.45"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(41.69 241.76) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="308.38"
          y="-4.65"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(50.4 225.79) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="360.19"
          y="65.82"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(23.74 273.65) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="343.04"
          y="35.01"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(32.98 257.65) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="366.97"
          y="39.13"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 42.63, 271.69)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="349.82"
          y="8.32"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(51.87 255.69) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="384.44"
          y="49.47"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(33.46 287.89) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="398.65"
          y="46.52"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(45.38 293.95) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="381.49"
          y="15.72"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(54.61 277.95) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="358.5"
          y="-11.39"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(66.69 256.63) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="390.82"
          y="-4.03"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(69.61 279.29) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="408.39"
          y="26.88"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 60.41, 295.58)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="425.94"
          y="37.52"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(51.06 311.92) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="416.62"
          y="56.54"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(36.53 310.4) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="443.62"
          y="33.76"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(64.33 320.03) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="426.47"
          y="2.95"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(73.57 304.03) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="461.09"
          y="44.1"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(55.16 336.23) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="488.19"
          y="50.82"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(63.88 352.93) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="470.78"
          y="20.74"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(72.59 336.95) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="505.44"
          y="60.4"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(55.16 368.82) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="443.01"
          y="69"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(41.37 328.01) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="497.77"
          y="27.46"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(81.28 353.58) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="480.37"
          y="-2.64"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(90.01 337.6) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="532.19"
          y="67.82"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(63.35 385.46) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="515.04"
          y="37.01"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(72.58 369.47) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="534.97"
          y="38.13"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 83.22, 380.2)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="519.17"
          y="6.24"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(94.61 366.26) rotate(-40.54)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="552.43"
          y="48.48"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(74.05 396.4) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="566.66"
          y="45.54"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(85.96 402.48) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="549.48"
          y="14.72"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(95.2 386.46) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="526.5"
          y="-12.39"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(107.28 365.14) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="558.81"
          y="-5.02"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(110.2 387.8) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="576.37"
          y="25.88"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(101 404.09) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="593.94"
          y="36.53"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(91.65 420.43) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="584.61"
          y="55.55"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 77.12, 418.91)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="611.62"
          y="32.77"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(104.92 428.54) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="594.45"
          y="1.94"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(114.16 412.53) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="629.09"
          y="43.11"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(95.75 444.75) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="656.18"
          y="49.84"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(104.47 461.44) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="638.78"
          y="19.75"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(113.18 445.46) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="673.45"
          y="59.41"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(95.75 477.33) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="611"
          y="68.01"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(81.96 436.52) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="665.76"
          y="26.45"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(121.88 462.08) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="650.05"
          y="-5.05"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(133.36 448.62) rotate(-40.54)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="700.18"
          y="66.83"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(103.93 493.97) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="683.03"
          y="36.02"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(113.17 477.97) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="707.97"
          y="39.14"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(123.7 492.42) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="690.8"
          y="8.33"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(132.94 476.42) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="725.44"
          y="49.48"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(114.54 508.63) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="739.64"
          y="46.54"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(126.45 514.68) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="722.48"
          y="15.72"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(135.69 498.68) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="701.29"
          y="-12.93"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(150.78 480.04) rotate(-40.54)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="731.8"
          y="-4.01"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(150.68 500.02) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="749.37"
          y="26.89"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(141.48 516.32) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="766.94"
          y="37.55"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(132.13 532.65) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="757.61"
          y="56.56"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(117.6 531.13) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="784.62"
          y="33.77"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(145.41 540.76) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="767.45"
          y="2.94"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 154.65, 524.76)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="802.08"
          y="44.11"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(136.24 556.96) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="829.17"
          y="50.85"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(144.95 573.66) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="811.78"
          y="20.75"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(153.67 557.68) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="846.44"
          y="60.41"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 136.24, 589.55)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="784"
          y="69.01"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(122.45 548.74) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="838.75"
          y="27.47"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(162.36 574.31) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="821.36"
          y="-2.63"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(171.08 558.33) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="873.17"
          y="67.84"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(144.41 606.19) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="856.02"
          y="37.04"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(153.64 590.2) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="877.96"
          y="39.14"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 164.13, 602.47)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="860.8"
          y="8.34"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(173.36 586.47) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="895.41"
          y="49.49"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(154.95 618.66) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="909.63"
          y="46.54"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(166.87 624.73) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="892.46"
          y="15.73"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(176.1 608.72) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="869.48"
          y="-11.37"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(188.18 587.4) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="901.78"
          y="-4"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(191.09 610.06) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="919.36"
          y="26.88"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(181.9 626.35) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="936.92"
          y="37.55"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(172.55 642.69) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="927.6"
          y="56.57"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(158.02 641.18) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="954.6"
          y="33.77"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(185.83 650.8) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="937.44"
          y="2.96"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(195.06 634.8) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="972.07"
          y="44.1"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(176.66 667) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="999.17"
          y="50.84"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(185.37 683.71) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="981.77"
          y="20.76"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(194.08 667.73) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1016.44"
          y="60.4"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(176.66 699.59) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="953.97"
          y="69.02"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(162.86 658.78) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1008.74"
          y="27.47"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="matrix(0.76, -0.65, 0.65, 0.76, 202.78, 684.35)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="991.35"
          y="-2.62"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(211.49 668.37) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1043.18"
          y="67.84"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(184.83 716.24) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1026"
          y="37.04"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(194.06 700.23) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1047.96"
          y="39.16"
          width="7.95"
          height="11.87"
          rx="3.43"
          transform="translate(204.54 712.51) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1030.78"
          y="8.34"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(213.77 696.5) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1065.42"
          y="49.49"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(195.37 728.71) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1062.47"
          y="15.74"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(216.52 718.77) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1039.48"
          y="-11.36"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(228.6 697.45) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1071.78"
          y="-4"
          width="7.95"
          height="32.35"
          rx="3.43"
          transform="translate(231.51 720.11) rotate(-40.34)"
          fill={secondary}
          opacity="0.24"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="28.03"
          y="34.25"
          width="11.96"
          height="16.67"
          rx="5.17"
          transform="translate(-35.89 52.99) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="54.05"
          y="8.03"
          width="12.54"
          height="16.67"
          rx="5.42"
          transform="translate(-12.66 63.79) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="108.59"
          y="13.08"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(-2.96 100.28) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="75.03"
          y="21.76"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(-23.49 83.05) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="48.88"
          y="48.33"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(-46.91 72.44) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="129.17"
          y="26.48"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(-13.68 119.21) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="96.35"
          y="57.56"
          width="12.54"
          height="16.67"
          rx="5.42"
          transform="translate(-34.66 102.95) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="178.27"
          y="36.99"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(-1.87 151.07) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="157.76"
          y="2.44"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(8.68 132) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="198.69"
          y="50.71"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(-12.83 169.98) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="232.75"
          y="41.89"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(7.91 187.5) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="212.23"
          y="7.35"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(18.46 168.43) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="253.16"
          y="55.62"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(-3.06 206.4) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="261.53"
          y="10.98"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(34.77 198.78) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="241.02"
          y="-23.58"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(45.32 179.71) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="281.95"
          y="24.71"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(23.8 217.69) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="306.36"
          y="-10.27"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(52.25 225.18) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="326.14"
          y="24.36"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(41.46 243.78) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="340.02"
          y="43.25"
          width="11.96"
          height="16.67"
          rx="5.17"
          transform="translate(32.47 257.09) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="366.02"
          y="17.05"
          width="12.54"
          height="16.67"
          rx="5.42"
          transform="translate(55.69 267.88) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="420.58"
          y="22.07"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(65.4 304.37) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="387.02"
          y="30.76"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(44.87 287.14) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="360.87"
          y="57.35"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(21.44 276.54) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="441.16"
          y="35.51"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(54.67 323.32) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="408.34"
          y="66.57"
          width="12.54"
          height="16.67"
          rx="5.42"
          transform="translate(33.7 307.05) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="490.26"
          y="46"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(66.48 355.17) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="469.75"
          y="11.45"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(77.04 336.1) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="510.69"
          y="59.71"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(55.53 374.08) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="544.72"
          y="50.9"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(76.26 391.59) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="524.23"
          y="16.36"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(86.82 372.54) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="565.15"
          y="64.63"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(65.3 410.5) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="573.53"
          y="19.99"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(103.12 402.88) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="553.01"
          y="-14.56"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(113.67 383.81) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="593.94"
          y="33.71"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(92.16 421.79) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="618.36"
          y="-1.27"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(120.61 429.28) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="638.13"
          y="33.35"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(109.83 447.88) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="664.01"
          y="12.26"
          width="11.96"
          height="16.67"
          rx="5.17"
          transform="translate(129.57 459.44) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="711.02"
          y="-0.22"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(141.96 489.51) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="686.73"
          y="24.94"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(121.35 481.7) rotate(-40.54)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="765.15"
          y="4.52"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(151.77 525.67) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="732.31"
          y="35.58"
          width="12.54"
          height="16.67"
          rx="5.42"
          transform="translate(130.79 509.39) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="814.24"
          y="15.01"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(163.58 557.52) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="793.74"
          y="-19.55"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(174.14 538.46) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="834.67"
          y="28.74"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(152.62 576.43) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="868.71"
          y="19.91"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(173.36 593.94) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="848.2"
          y="-14.63"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(183.91 574.88) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="889.14"
          y="33.63"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(162.4 612.86) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="917.93"
          y="2.73"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(189.25 624.15) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="962.11"
          y="2.37"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(206.92 650.23) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="980.6"
          y="18.17"
          width="11.96"
          height="16.67"
          rx="5.17"
          transform="translate(203.19 668.47) rotate(-40.54)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1003.99"
          y="-5.93"
          width="12.54"
          height="16.67"
          rx="5.42"
          transform="translate(222.26 675.39) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1058.56"
          y="-0.9"
          width="12.48"
          height="16.67"
          rx="5.39"
          transform="translate(231.97 711.89) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1024.99"
          y="7.79"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(211.43 694.65) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="998.84"
          y="34.35"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(188.02 684.04) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1079.13"
          y="12.52"
          width="12.16"
          height="37.97"
          rx="5.25"
          transform="translate(221.25 730.82) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
        <rect
          x="1046.32"
          y="43.6"
          width="12.54"
          height="16.67"
          rx="5.42"
          transform="translate(200.27 714.56) rotate(-40.34)"
          fill={secondary}
          opacity="0.4"
          style={{ isolation: "isolate" }}
        />
      </g>
    </svg>
  );
};

export default Pills;
